<template>
  <div>
    <div v-if="loading_page === true">
      <v-sheet :color="`grey ${theme.isDark ? 'darken-2' : 'lighten-4'}`" class="pa-3">
        <v-skeleton-loader type="article, actions"></v-skeleton-loader>
      </v-sheet>
    </div>
    <div v-else>
      <v-card elevation="6">
        <v-slide-x-reverse-transition>
          <v-alert type="success" class="alert" v-if="alert_success === true">เพิ่มข้อมูลเรียบร้อย !</v-alert>
          <v-alert type="error" class="alert" v-if="alert_danger === true">ลบข้อมูลเรียบร้อย !</v-alert>
        </v-slide-x-reverse-transition>
        <div class="pa-3">
          <v-form ref="quotation_add" @submit.prevent="Create_quotation">
            <div class="grid_half">
              <div class="d-flex mt-6 ml-2">
                <div class="mr-2" style="font-size: 24px">เลขที่ใบเสนอราคา</div>
                <div style="font-size: 24px">{{ save_data.quotation_code }}</div>
              </div>
              <div class="mt-3">
                <div class="mr-1">
                  <v-menu ref="menu_date" v-model="menu_date" :close-on-content-click="false" :return-value.sync="save_data.quotation_date" transition="scale-transition" offset-y min-width="auto">
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field color="#86bc3a" v-model="save_data.quotation_date" label="วันที่เสนอราคา (วัน/เดือน/ปี)" :rules="[v => !!v || 'กรุณากรอกวันที่เสนอราคา']" prepend-inner-icon="mdi-calendar" readonly v-bind="attrs" v-on="on" outlined></v-text-field>
                    </template>
                    <v-date-picker locale="TH" color="#86bc3a" @change="diffDateTH(dateEN)" v-model="dateEN" no-title scrollable>
                      <v-spacer></v-spacer>
                      <v-btn text color="primary" @click="selectDate()">
                        ตกลง
                      </v-btn>
                      <v-btn text color="primary" @click="menu_date = false">
                        ยกเลิก
                      </v-btn>
                    </v-date-picker>
                  </v-menu>
                </div>
              </div>
              <div class="mt-1 mr-1">
                <v-text-field color="#86bc3a" label="ชื่อลูกค้า" prepend-inner-icon="mdi-account-outline" :rules="[v => !!v || 'กรุณากรอกชื่อลูกค้า']" hide-details="auto" v-model="save_data.name" outlined></v-text-field>
              </div>
              <div class="mt-1 mr-1">
                <v-text-field color="#86bc3a" label="เบอร์โทร" type="tel" maxlength="11" prepend-inner-icon="mdi-phone-outline" @keypress="isNumber($event, save_data.telephone)" :rules="phoneRules" hide-details="auto" v-model="save_data.telephone" outlined></v-text-field>
              </div>
            </div>
            <div class="grid_full">
              <div class="mt-4 mr-1">
                <v-text-field color="#86bc3a" label="ที่อยู่" prepend-inner-icon="mdi-home-outline" hide-details="auto" :rules="[v => !!v || 'กรุณากรอกที่อยู่']" v-model="save_data.address" outlined></v-text-field>
              </div>
            </div>
            <div class="grid_four">
              <div class="mt-3 mr-1">
                <addressinput-subdistrict :store="mainDataStore" class="custom_css" placeholder="ตำบล/แขวง" v-model="save_data.sub_district"/>
              </div>
              <div class="mt-3 mr-1">
                <addressinput-district :store="mainDataStore" class="custom_css" placeholder="อำเภอ/เขต" v-model="save_data.district"/>
              </div>
              <div class="mt-3 mr-1">
                <addressinput-province :store="mainDataStore" class="custom_css" placeholder="จังหวัด" v-model="save_data.province"/>
              </div>
              <div class="mt-3 mr-1">
                <addressinput-zipcode numbered :store="mainDataStore" class="custom_css" placeholder="รหัสไปรษณีย์" v-model="save_data.postcode"/>
              </div>
            </div>
            <div class="grid_delivery">
              <span class="pl-2 mt-5">การจัดส่ง</span>
              <div class="grid_delivery">
                <v-radio-group v-model="save_data.delivery_type" @change="deliveryType()" mandatory>
                  <div class="d-flex justify-space-around">
                    <div class="d-flex mr-1">
                      <div>
                        <v-radio color="#86bc3a" :value="0"></v-radio>
                      </div>
                      <div>รับที่ร้าน</div>
                    </div>
                    <div class="d-flex ml-1">
                      <div>
                        <v-radio color="#86bc3a" :value="1"></v-radio>
                      </div>
                      <div>ส่งพัสดุ</div>
                    </div>
                  </div>
                </v-radio-group>
              </div>
            </div>
            <v-card-title>
              รายการสินค้า
            </v-card-title>
            <div class="mt-3 mr-1">
              <v-autocomplete clearable color="#86bc3a" :items="product_all" item-text="name" item-value="id" @input="add_product_list(product_id)" v-model="product_id" prepend-inner-icon="mdi-cart-outline" label="ค้นหารายการสินค้า" hide-details="auto" outlined/>
            </div>
            <v-data-table :headers="headers" :items="data_list" key="index" :footer-props="footer_Props" hide-default-footer mobile-breakpoint="0">
              <template slot="item" slot-scope="dataDetail">
                <tr>
                  <td>{{ dataDetail.index + 1 }}</td>
                  <td>
                    <div v-if="dataDetail.item.name !== null">
                      {{ dataDetail.item.name }}
                    </div>
                    <div v-else>-</div>
                  </td>
                  <td class="pa-3">
                    <v-select color="#86bc3a" :items="dataDetail.item.product_lists" item-text="name" item-value="unit_id" @change="change_price(dataDetail.item.loop_id, dataDetail.item.unit_id)" v-model="dataDetail.item.unit_id" label="หน่วยนับ" hide-details="auto" outlined></v-select>
                  </td>
                  <td class="pa-3">
                    <v-text-field color="#86bc3a" type="number" min="0" label="จำนวน" @input="checkMax_value()" @keypress="isOnlyNumber($event, dataDetail.item.qty)" hide-details="auto" :rules="[v => !!v || 'กรุณากรอกจำนวน']" required v-model="dataDetail.item.qty" outlined></v-text-field>
                  </td>
                  <td class="pa-3">
                    <v-text-field color="#86bc3a" type="number" min="0" label="หน่วยละ" @input="checkMax_value()" @keypress="isCurrency($event, dataDetail.item.price_unit)" hide-details="auto" :rules="[v => !!v || 'กรุณากรอกหน่วยละ']" required v-model="dataDetail.item.price_unit" outlined></v-text-field>
                  </td>
                  <td>
                    {{ format_price(dataDetail.item.total = (dataDetail.item.qty * dataDetail.item.price_unit)) }}
                  </td>
                  <td class="pa-3">
                    <v-btn small type="button" height="42" @click="getDelete(dataDetail.item.loop_id)" class="grad-danger-bg white--text mb-1">
                      <v-icon>mdi-delete-empty-outline</v-icon>
                    </v-btn>
                  </td>
                </tr>
              </template>
              <template v-slot:body.append>
                <tr>
                  <td colspan="6" class="text-center">ค่าจัดส่ง</td>
                  <td>{{ format_price(delivery_price) }}</td>
                </tr>
                <tr>
                  <td colspan="6" class="text-center">จำนวนเงินรวม</td>
                  <td>{{ format_price(total + parseFloat(delivery_price)) }}</td>
                </tr>
              </template>
            </v-data-table>
            <v-divider/>
            <div class="grid_full">
              <div class="mt-3 mr-1">
                <v-textarea color="#86bc3a" style="font-size: 18px !important" label="หมายเหตุ" prepend-inner-icon="mdi-message-bulleted" hide-details="auto" v-model="save_data.note" outlined></v-textarea>
              </div>
            </div>
            <div class="text-right mt-5 mr-1 mb-3">
              <v-btn type="submit" height="45" class="white--text grad-success-bg btn_mobile" style="font-size: 18px">บันทึกใบเสนอราคา</v-btn>
            </div>
          </v-form>
        </div>
        <v-overlay :value="overlay" class="z_index">
          <div class="text-center">
            <v-progress-circular
                indeterminate
                size="70"
                width="7"
                color="#86bc3a"
            ></v-progress-circular>
            <div>โปรดรอสักครู่ระบบกำลังประมวลผล...</div>
          </div>
        </v-overlay>
      </v-card>
    </div>
  </div>
</template>

<script>
import { DataStore,  } from 'vue-thailand-address';
import {HTTP} from "@/axios";
import Swal from "sweetalert2";
import {formatPrice, isTelephone, onlyForCurrency, onlyForNumber} from "@/js/handler";
const mainDataStore = new DataStore();
const subDataStore = new DataStore();

export default {
  inject: {
    theme: {
      default: {
        isDark: false
      },
    },
  },
  name: "Quotation_create",
  data() {
    return {
      mainDataStore,
      subDataStore,
      loading_page: false,
      loading_data: false,
      overlay: false,
      alert_success: false,
      alert_danger: false,
      phoneRules: [v => ( v.length === 10 ) || "เบอร์โทรศัพท์ไม่ถูกต้อง !",],
      date: '',
      dateEN: '',
      menu_date: false,
      product_id: null,
      loop_id: null,
      footer_Props: {
        // showFirstLastPage: true,
        // firstIcon: 'mdi-arrow-collapse-left',
        // lastIcon: 'mdi-arrow-collapse-right',
        // prevIcon: 'mdi-minus',
        // nextIcon: 'mdi-plus',
        'items-per-page-text':'รายการต่อหน้า'
      },
      product_all: [],
      product_lists: [],
      headers: [
        {
          text: 'ลำดับ',
          value: 'id',
          fixed: true,
          width: '100px',
        },
        {
          text: 'รายละเอียดสินค้า',
          value: 'name',
          fixed: true,
          width: '175px',
        },
        {
          text: 'หน่วยนับ',
          value: '',
          sortable: false,
          fixed: true,
          width: '125px',
        },
        {
          text: 'จำนวน',
          value: 'qty',
          fixed: true,
          width: '145px',
        },
        {
          text: 'หน่วยละ',
          value: 'price_unit',
          fixed: true,
          width: '150px',
        },
        {
          text: 'จำนวนเงิน',
          value: 'total',
          fixed: true,
          width: '125px',
        },
        {
          text: '',
          value: '',
          sortable: false,
          fixed: true,
          width: '100px',
        },
      ],
      data_list: [],
      data_list_save: [],
      save_data: {
        quotation_date: '',
        quotation_code: null,
        telephone: '',
        name: null,
        address: null,
        sub_district: null,
        district: null,
        province: null,
        postcode: null,
        delivery_type: 0,
        note: 'ราคานี้รวมภาษีมูลค่าเพิ่มแล้ว อ้างอิงราคานี้ได้ไม่เกิน 7 วัน',
        grand_total: null,
      },
      weight_list:[],
      delivery_price: 0,
    }
  },
  methods: {
    async selectDate() {
      this.$refs.menu_date.save(this.save_data.quotation_date)
      this.menu_date = false
    },
    isNumber: function (evt, number) {
      return isTelephone(evt, number)
    },
    isOnlyNumber: function (evt, number) {
      return onlyForNumber(evt, number)
    },
    isCurrency: function (evt, number) {
      return onlyForCurrency(evt, number)
    },
    format_price: function (value) {
      return formatPrice(value)
    },
    diffDateTH(value) {
      const diff = value.split('-')
      const day = diff[2]
      const month = diff[1]
      const year = parseInt(diff[0])+ 543
      const final_date = day+'-'+month+'-'+year
      return this.save_data.quotation_date = final_date
    },
    diffDateEN() {
      const diff = this.save_data.quotation_date.split('-')
      const year = parseInt(diff[2]) - 543
      const month = diff[1]
      const day = diff[0]
      return year+'-'+month+'-'+day
    },
    async get_product() {
      this.loading_page = true
      await  HTTP.post('/quotations/getqtocode')
      .then((res) => {
        if (res.data.success === true) {
          this.save_data.quotation_code = res.data.object
        }
      })

      await HTTP.post('/quotations/getallproducts')
          .then((res) => {
            if (res.data.success === true) {
              this.product_all = res.data.products
            }
          })

      let weight_arr = []
      await HTTP.get('wholesales/price_rate')
          .then((res) => {
            if (res.data.success === true) {
              res.data.price_rate.forEach((data) => {
                weight_arr.push({
                  id: data.id,
                  rate_end: data.rate_end !== null ? data.rate_end : '0.00',
                  rate_price: data.rate_price,
                  rate_start: data.rate_start !== null ? data.rate_start : '0.00',
                  rate_type: data.rate_type,
                })
              })
              this.weight_list = weight_arr
              this.loading_page = false
            }
          })
    },
    async add_product_list(product_id) {
      await HTTP.post('/quotations/getunitsproduct', {
        product_id: product_id
      }).then((res) => {
        if (res.data.success === true) {
          this.product_lists = res.data.object
        }
      })
      let value = this.product_all.filter((res) => {
        return res.id === product_id
      })
      value.forEach((data) => {
        const id = this.loop_id +=1;
        this.data_list.push({
          loop_id: id,
          id: data.id,
          product_code: data.product_code,
          name: data.name,
          unit_id: data.unit_id,
          productlist_id: this.product_lists.filter(function (obj) {
            return obj.unit_id == data.unit_id
          }).map(function (obj) { return obj.productlist_id }).toString(),
          min_qty: data.min_qty,
          product_lists: this.product_lists,
          qty: '',
          price_unit: this.product_lists.filter(function (obj) {
            return obj.unit_id == data.unit_id
          }).map(function (obj) { return obj.retail_price }).toString(),
          total: 0,
        })
      })
      await this.$nextTick(() => {
        this.product_id = null;
        this.alert_success = true;
        setTimeout(() => this.alert_success = false, 2000);
      })
    },
    deliveryType(){
      const result = this.data_list.reduce((sum,number) => {
        let value = number.product_lists.find(detail => {
          return detail.unit_id == number.unit_id
        })
        let qty = number.qty
        if (!number.qty) {
          qty = 0
        }
        let total_weight = parseFloat(qty) * parseFloat(value.weight)
        if (total_weight < 0) {
          return sum+(0)
        }
        else {
          return sum+parseFloat(total_weight);
        }
      }, 0)

      let math_weight = parseFloat(result)
      if (math_weight !== 0) {
        let result_weight = null
        this.weight_list.forEach((data) => {
          if (data.rate_type == 1 && math_weight >= parseFloat(data.rate_start) && math_weight <= parseFloat(data.rate_end)) {
              result_weight = data
              return
          }else if(data.rate_type == 2 && math_weight <= parseFloat(data.rate_start)){
              result_weight = data
              return
          }else if(data.rate_type == 3 && math_weight >= parseFloat(data.rate_start)){
              result_weight = data
              return
          }
        })
        this.delivery_price = result_weight.rate_price
      }
      else {
        this.delivery_price = 0
      }

      if (this.save_data.delivery_type == 0) {
        this.delivery_price = 0
      }
    },
    checkMax_value() {
      const result = this.data_list.reduce((sum,number) => {
        let value = number.product_lists.find(detail => {
          return detail.unit_id == number.unit_id
        })
        let qty = number.qty
        if (!number.qty) {
          qty = 0
        }
        let total_weight = parseFloat(qty) * parseFloat(value.weight)
        if (total_weight < 0) {
          return sum+(0)
        }
        else {
          return sum+parseFloat(total_weight);
        }
      }, 0)

      let math_weight = parseFloat(result)
      if (math_weight !== 0) {
        let result_weight = null
        this.weight_list.forEach((data) => {
          if (data.rate_type == 1 && math_weight >= parseFloat(data.rate_start) && math_weight <= parseFloat(data.rate_end)) {
              result_weight = data
              return
          }else if(data.rate_type == 2 && math_weight <= parseFloat(data.rate_start)){
              result_weight = data
              return
          }else if(data.rate_type == 3 && math_weight >= parseFloat(data.rate_start)){
              result_weight = data
              return
          }
        })
        this.delivery_price = result_weight.rate_price
      }
      else {
        this.delivery_price = 0
      }

      if (this.save_data.delivery_type == 0) {
        this.delivery_price = 0
      }
    },
    change_price(loop_id, unit_id) {
      this.data_list.forEach((data) => {
        if (loop_id === data.loop_id) {
          data.price_unit = data.product_lists.filter(function (obj) {return obj.unit_id == unit_id}).map(function (obj) { return obj.retail_price }).toString()
        }
      })

      const result = this.data_list.reduce((sum,number) => {
        let value = number.product_lists.find(detail => {
          return detail.unit_id == number.unit_id
        })
        let qty = number.qty
        if (!number.qty) {
          qty = 0
        }
        let total_weight = parseFloat(qty) * parseFloat(value.weight)
        if (total_weight < 0) {
          return sum+(0)
        }
        else {
          return sum+parseFloat(total_weight);
        }
      }, 0)

      let math_weight = parseFloat(result)
      if (math_weight !== 0) {
        let result_weight = null
        this.weight_list.forEach((data) => {
          if (data.rate_type == 1 && math_weight >= parseFloat(data.rate_start) && math_weight <= parseFloat(data.rate_end)) {
              result_weight = data
              return
          }else if(data.rate_type == 2 && math_weight <= parseFloat(data.rate_start)){
              result_weight = data
              return
          }else if(data.rate_type == 3 && math_weight >= parseFloat(data.rate_start)){
              result_weight = data
              return
          }
        })
        this.delivery_price = result_weight.rate_price
      }
      else {
        this.delivery_price = 0
      }

      if (this.save_data.delivery_type == 0) {
        this.delivery_price = 0
      }
    },
    getDelete(loop_id) {
      this.data_list = this.data_list.filter((data) => data.loop_id !== loop_id)

      const result = this.data_list.reduce((sum,number) => {
        let value = number.product_lists.find(detail => {
          return detail.unit_id == number.unit_id
        })
        let qty = number.qty
        if (!number.qty) {
          qty = 0
        }
        let total_weight = parseFloat(qty) * parseFloat(value.weight)
        if (total_weight < 0) {
          return sum+(0)
        }
        else {
          return sum+parseFloat(total_weight);
        }
      }, 0)

      let math_weight = parseFloat(result)
      if (math_weight !== 0) {
        let result_weight = null
        this.weight_list.forEach((data) => {
          if (data.rate_type == 1 && math_weight >= parseFloat(data.rate_start) && math_weight <= parseFloat(data.rate_end)) {
              result_weight = data
              return
          }else if(data.rate_type == 2 && math_weight <= parseFloat(data.rate_start)){
              result_weight = data
              return
          }else if(data.rate_type == 3 && math_weight >= parseFloat(data.rate_start)){
              result_weight = data
              return
          }
        })
        this.delivery_price = result_weight.rate_price
      }
      else {
        this.delivery_price = 0
      }

      if (this.save_data.delivery_type == 0) {
        this.delivery_price = 0
      }
      this.alert_danger = true
      setTimeout(() => this.alert_danger = false, 2000)
    },
    Create_quotation() {
      if (this.$refs.quotation_add.validate()) {
        this.data_list_save = []
        this.data_list.forEach((data) => {
          this.data_list_save.push({
            id: data.id,
            product_code: data.product_code,
            name: data.name,
            unit_id: data.unit_id,
            productlist_id: data.product_lists.filter(function (obj) {
              return obj.unit_id == data.unit_id
            }).map(function (obj) { return obj.productlist_id }).toString(),
            min_qty: data.min_qty,
            qty: data.qty,
            price_unit: data.price_unit,
            total: data.total,
          })
        })
        if (this.save_data.quotation_date !== null && this.save_data.name !== null && this.save_data.telephone !== null && this.save_data.quotation_date !== '' && this.save_data.name !== '' && this.save_data.telephone !== '') {
          if (this.data_list.length !== 0) {
            this.overlay = true
            HTTP.post('/quotations/create', {
              quo_type: 1,
              user_id: this.$store.state.userDetail.id,
              user_name: this.$store.state.userDetail.name,
              quotation_code: this.save_data.quotation_code,
              date: this.diffDateEN(),
              telephone: this.save_data.telephone,
              customer_name: this.save_data.name,
              address: this.save_data.address,
              sub_district: this.save_data.sub_district,
              district: this.save_data.district,
              province: this.save_data.province,
              postcode: this.save_data.postcode,
              delivery_type: this.save_data.delivery_type,
              note: this.save_data.note,
              delivery_price:this.delivery_price,
              total: parseFloat(this.total) + parseFloat(this.delivery_price),
              lists: this.data_list_save,
            }).then((res) => {
              if (res.data.success === true) {
                this.overlay = false
                Swal.fire({
                  title: 'บันทึกข้อมูลสำเร็จ !',
                  icon: 'success',
                  showDenyButton: false,
                  showCancelButton: false,
                  confirmButtonText: `ตกลง`,
                  denyButtonText: `ยกเลิก`,
                }).then((result) => {
                  if (result.isConfirmed === true) {
                    this.$router.push('/stock/quotation/quotationmain')
                  }
                  else {
                    this.$router.push('/stock/quotation/quotationmain')
                  }
                })
              }
            })
          }
          else {
            Swal.fire({
              title: 'ไม่สามารถดำเนินการได้ !',
              text: 'ไม่มีรายการสินค้า !',
              icon: 'error',
              showDenyButton: false,
              showCancelButton: false,
              confirmButtonText: `ตกลง`,
              denyButtonText: `ยกเลิก`,
            })
          }
        }
        else {
          Swal.fire({
            title: 'ไม่สามารถดำเนินการได้ !',
            text: 'กรุณากรอกข้อมูล !',
            icon: 'error',
            showDenyButton: false,
            showCancelButton: false,
            confirmButtonText: `ตกลง`,
            denyButtonText: `ยกเลิก`,
          }).then(() => {
            this.$refs.quotation_add.validate()
          })
        }
      }
    }
  },
  computed: {
    total() {
      let data_list = this.data_list;
      const result = data_list.reduce((sum, number) => {
       return sum+number.total
      }, 0)
      return result;
    },
  },
  mounted() {
    this.get_product()
  }
}
</script>

<style scoped>
.custom_css >>> input {
  font-size: 18px;
  border-color: #9b9b9b;
  border-radius: 5px;
  padding: 16px;
  height: 56px !important;
}
.custom_css >>> input:hover {
  border-color: black;
}
.custom_css >>> input:focus {
  border-color: #8cc63e !important;
  border: solid 2px;
  padding: 15px;
}
.custom_css >>> ul {
  max-height: 200px;
  list-style: none;
  margin: 0;
  overflow-y: auto;
  padding: 0;
  position: absolute;
  width: 100%;
  z-index: 1;
  font-size: 16px;
}
.grid_half {
  display: grid;
  grid-template-columns: 50% 50%;
  grid-gap: 15px 0;
}
.grid_full {
  display: grid;
  grid-template-columns: 100%;
  grid-gap: 15px 0;
}
.grid_four {
  display: grid;
  grid-template-columns: 25% 25% 25% 25%;
}
.grid_delivery {
  display: grid;
  grid-template-columns: 50%;
}
@media only screen and (max-width: 1440px) {
  .custom_css >>> ul {
    max-height: 200px;
    list-style: none;
    margin: 0;
    overflow-y: auto;
    padding: 0;
    position: absolute;
    width: 100%;
    z-index: 1;
    font-size: 14px;
  }
}
@media only screen and (max-width: 1180px){
  .grid_half {
    display: grid;
    grid-template-columns: 50% 50%;
    grid-gap: 15px 0;
  }
  .grid_four {
    display: grid;
    grid-template-columns: 50% 50%;
    grid-gap: 15px 0;
  }
  .btn_mobile {
    width: 40%;
  }
}
@media only screen and (max-width: 500px){
  .grid_half {
    display: grid;
    grid-template-columns: 100%;
    grid-gap: 15px 0;
  }
  .grid_four {
    display: grid;
    grid-template-columns: 100%;
    grid-gap: 15px 0;
  }
  .grid_delivery {
    display: grid;
    grid-template-columns: 50%;
  }
  .btn_mobile {
    width: 100%;
  }
}
</style>
